export const EnvironmentViolationTypes = {
  CIRCULAR: 'CIRCULAR'
};
export const isCircularViolation = violation => violation.type === EnvironmentViolationTypes.CIRCULAR;
export const isEnvironmentViolation = violation => isCircularViolation(violation);